import { Flex, Tabs } from '@bynder/design-system';
import {
  IconNormalScript,
  IconSubscript,
  IconSuperscript,
} from '@bynder/icons';
import { useContext } from 'react';
import { TeaClientContext } from './tea-editor-controls.tsx';

export function ScriptControl() {
  const { editor } = useContext(TeaClientContext);
  const isSuperscript = editor?.isActive('superscript');
  const isSubscript = editor?.isActive('subscript');

  return (
    <Flex gap="3" direction="column">
      <Tabs variant="clean">
        <Tabs.Tab
          isActive={!isSuperscript && !isSubscript}
          label="Remove subscript and superscript"
          isLabelHidden
          icon={<IconNormalScript />}
          onClick={() => {
            editor?.chain().unsetSubscript().unsetSuperscript().focus().run();
          }}
        />
        <Tabs.Tab
          isActive={isSuperscript}
          label={
            editor?.isActive('superscript')
              ? 'Remove superscript'
              : 'Apply superscript'
          }
          isLabelHidden
          icon={<IconSuperscript />}
          onClick={() => {
            editor?.chain().unsetSubscript().toggleSuperscript().focus().run();
          }}
        />
        <Tabs.Tab
          isActive={isSubscript}
          label={
            editor?.isActive('subscript')
              ? 'Remove subscript'
              : 'Apply subscript'
          }
          isLabelHidden
          icon={<IconSubscript />}
          onClick={() => {
            editor?.chain().unsetSuperscript().toggleSubscript().focus().run();
          }}
        />
      </Tabs>
    </Flex>
  );
}
